<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #F3F3F3;
}
#app .wh_content_all{
  background: none;
}
#app .wh_container{
  max-width: 500px;
}
#app .wh_content_item .wh_isToday{
  border: 1px solid #fff;
  background: none;
}
#app .wh_content_item .wh_chose_day{
  background: #b9e7ff;
  color: #ababab;
  border: 1px solid #b9e7ff;
}

#app .el-select .el-input__inner{
  background: #1C4F7E;
  font-size: 20px;
  height: 40px;
  width: 584px;
  border: 1px solid #5781AB;
  color: #B5E3FB;
}
#app .el-input__inner{
  background: #1C4F7E;
  border: 1px solid #5781AB;
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  color:#B5E3FB;
}
#app .el-select-dropdown{
  background: none;
}
.amap-icon img{
  width: 100%;
  height: 100%;
}
#app .el-radio__label{
  font-size: 24px;
  padding-left: 5px;
  color: #fff;
}
#app .el-radio__inner{
  width: 25px;
  height: 25px;
  border-width: 2px;
  background: none;
}
#app .el-radio__input.is-checked .el-radio__inner{
  background: none;
  border:2px solid #fbb50b;
}
#app .el-radio__input.is-checked+.el-radio__label{
  color: #fbb50b;
}
#app .el-radio__inner::after{
  width: 15px;
  height: 15px;
  background-color: #fbb50b;
}

.el-select-dropdown__item.hover,.el-select-dropdown__item:hover,.el-select-dropdown__item.selected{
  background:linear-gradient(90deg,rgba(87,129,171,1) 0%,rgba(87,129,171,0) 100%);
}
.el-select-dropdown__item.selected{
  background: none;
}
.el-select-dropdown{
  background: #1C4F7E;
  border-color: #5781AB;
}
.el-select-dropdown__item{
  font-size: 20px;
  color: #fff;
}
.el-popover{
  background: #1C4F7E;
  border-color: #5781AB;
  padding: 0 0 12px 0;
  /* position: relative; */
}
.el-popover .el-button{
  padding: 0;
  margin-left: 11px;
  margin-top: 12px;    
  font-size: 17px;
  background: #3B69A2;
  border: none;
  color: #fff;
  width: 40px;
  height: 40px;
  box-sizing: border-box;
}
.el-popover .el-button:focus,.el-popover .el-button:hover{
  background: #183253;
}
.el-popper[x-placement^=bottom] .popper__arrow::after{
  display: none;
}
html,
body{
  width: 100%;
  margin: 0;
  padding: 0;
  background-color:transparent;
}
a{
  text-decoration: none;
}
i{
  font-style: normal;
 
}
.list_dec i{
  padding: 2px 10px;
  margin-right: 10px;
  border-radius: 5px;
  font-size: 16px;
}
.list_dec svg{
  padding-right: 5px;
}
.free{
  color: #14c91c;
  border: 1px solid #14c91c;
}
.stop{
  color: #041427;
  border: 1px solid #041427;
}
.soso{
  color: #fbb50b;
  border: 1px solid #fbb50b;
}
.busy{
  color: #ed6724;
  border: 1px solid #ed6724;
}
</style>
